{
	"home": {
		"anomalies": {
			"empty": "Nessuna anomalia aperta",
			"kind": {
				"email_bounced": "Email rimbalzata",
				"offer_bounced": "Offerta non consegnata",
				"offer_not_sent": "Offerta non partita",
				"ranking_failed": "Calcolo non riuscito",
				"transmission_not_delivered": "Domanda non consegnata"
			},
			"no_residence": "Nessuna struttura",
			"open_all": "Vai agli invii",
			"opened": "aperta il {{date}}",
			"protocol": "prot. {{protocol}}",
			"title": "Anomalie aperte",
			"total_one": "{{count}} anomalia aperta",
			"total_other": "{{count}} anomalie aperte"
		},
		"calls": {
			"applications_one": "{{count}} domanda valida",
			"applications_other": "{{count}} domande valide",
			"closed_on": "Chiuso il {{date}}",
			"closes": "Chiude il {{date}}",
			"empty": "Nessuna struttura ha ancora un bando",
			"intake_open": "Caricamento delle domande dirette aperto",
			"monitoring": "Vai al monitoraggio dei bandi",
			"no_date": "Date da impostare",
			"offers": "Offerte in attesa: {{waiting}} · accettate: {{accepted}}",
			"offers_overdue": "Oltre il termine del gestore: {{count}}",
			"open_flags_one": "{{count}} segnalazione aperta",
			"open_flags_other": "{{count}} segnalazioni aperte",
			"title": "Bandi"
		},
		"dsu_quota": {
			"figures": "{{seats}} posti a tariffa DSU, soglia {{threshold}}",
			"missing_one": "Manca {{count}} posto",
			"missing_other": "Mancano {{count}} posti",
			"title": "Quota DSU sotto soglia"
		},
		"page_title": "Dashboard",
		"requests": {
			"empty": "Nessuna richiesta aperta",
			"no_name": "Nome non indicato",
			"open_all": "Vai all'assistenza",
			"opened": "aperta il {{date}}",
			"title": "Richieste di assistenza aperte",
			"total_one": "{{count}} richiesta aperta",
			"total_other": "{{count}} richieste aperte"
		}
	},
	"profile": {},
	"ranking_status": {
		"control": "In controllo, versione {{number}}",
		"final": "Definitiva, versione {{number}}",
		"page_disabled": "Pagina disabilitata",
		"published_review": "Pubblicata, versione {{number}}"
	},
	"sending_counters": {
		"acknowledged_one": "{{count}} vista",
		"acknowledged_other": "{{count}} viste",
		"awaiting_one": "{{count}} da vedere",
		"awaiting_other": "{{count}} da vedere",
		"delivered_one": "{{count}} consegnata",
		"delivered_other": "{{count}} consegnate",
		"none": "Nessuna domanda inviata",
		"not_delivered_one": "{{count}} non consegnata",
		"not_delivered_other": "{{count}} non consegnate",
		"problem_one": "{{count}} con un problema",
		"problem_other": "{{count}} con un problema",
		"sent_one": "{{count}} inviata",
		"sent_other": "{{count}} inviate"
	}
}
